import { useGetAllFeatureFlagQuery } from '../features/featureFlag/featureFlagApi';
import { ENTITLEMENTS_V2_FEATURE_FLAG } from '../constants';
import { FeatureFlagData } from '../types';

export const useEntitlementsV2Flag = (enabled = true): { isEntitlementsV2: boolean; isFlagLoading: boolean } => {
    const { data: featureFlags, isLoading } = useGetAllFeatureFlagQuery({}, { skip: !enabled });
    const flag = featureFlags?.data?.find((f: FeatureFlagData) => f.featureFlagName === ENTITLEMENTS_V2_FEATURE_FLAG);
    return { isEntitlementsV2: Boolean(flag?.enabled), isFlagLoading: isLoading };
};
